import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { ApplicationStepsConfiguration, ApplicationStepType } from './application-steps-generic.models';

@Component({
  selector: 'app-application-steps-generic',
  templateUrl: './application-steps-generic.component.html',
  styleUrls: ['./application-steps-generic.component.scss'],
})
export class ApplicationStepsGenericComponent extends DestroyableComponent implements OnInit, AfterViewInit {
  @Input() configuration: ApplicationStepsConfiguration;
  @Input() disabled: boolean;

  applicationStepType = ApplicationStepType;
  currentStepIndex: number;

  @ViewChildren(TemplateRef) templateList!: QueryList<TemplateRef<any>>;

  templates = null;

  constructor(public router: Router, private cd: ChangeDetectorRef) {
    super();
  }
  ngOnInit(): void {
    this.currentStepIndex = this.configuration.steps.findIndex(s => s.step === this.configuration.currentStep);
  }

  ngAfterViewInit(): void {
    this.templates = this.getTemplates();
    this.cd.detectChanges();
  }

  /**
   * Retrieves the list of templates from the `templateList` QueryList.
   * This method processes each template in the list, extracts its local name,
   * and maps it to the corresponding template reference.
   *
   * @returns An object where the keys are the local names of the templates and the values are the template references.
   */
  private getTemplates() {
    return this.templateList.toArray().reduce((aggr, current) => {
      const localNames = (current as any)._declarationTContainer?.localNames;
      if (!localNames) return aggr;
      const id = localNames[0];
      if (!id) return aggr;
      aggr[(current as any)._declarationTContainer.localNames[0]] = current;
      return aggr;
    }, {});
  }
}
